import { render, staticRenderFns } from "./NewRirekishoEdit.vue?vue&type=template&id=46e36522&scoped=true&"
import script from "./NewRirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./NewRirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewRirekishoEdit.vue?vue&type=style&index=0&id=46e36522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e36522",
  null
  
)

export default component.exports